/**
 * @generated SignedSource<<b0ec4fe1223be7a928a2b740c3c24cbb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type useMyProfileQuery$variables = {};
export type useMyProfileQuery$data = {
  readonly user: {
    readonly email: string | null;
    readonly name: string | null;
    readonly username: string | null;
  } | null;
};
export type useMyProfileQuery = {
  response: useMyProfileQuery$data;
  variables: useMyProfileQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "userLocator",
    "value": "current"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "username",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useMyProfileQuery",
    "selections": [
      {
        "alias": null,
        "args": (v0/*: any*/),
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": "user(userLocator:\"current\")"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useMyProfileQuery",
    "selections": [
      {
        "alias": null,
        "args": (v0/*: any*/),
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": "user(userLocator:\"current\")"
      }
    ]
  },
  "params": {
    "cacheID": "6e09e64b82847efb14d64961af106200",
    "id": null,
    "metadata": {},
    "name": "useMyProfileQuery",
    "operationKind": "query",
    "text": "query useMyProfileQuery {\n  user(userLocator: \"current\") {\n    name\n    username\n    email\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "7aabe889f48c362f490673a092266545";

export default node;
